import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import PropTypes from 'prop-types'
import { required, numericality, addValidator } from 'redux-form-validators';
import { connect } from 'react-redux';
import EditorMedia from '../../../helpers/Fields/EditorMedia/EditorMedia';
import Answers from './components/Answers';
import { subjectsSelector } from '../../../../modules/subjects';
import { currentSubjectSourcesSelector } from '../../../../modules/sources';
import { categorySelector, subcategoriesSelector, categoriesSelector } from '../../../../modules/categories';
import SelectFieldAnt from '../../../helpers/Fields/SelectFieldAnt';
import RateField from '../../../helpers/Fields/RateField';
import { saveQuestions } from '../actions';
import { deleteImgs } from '../../../helpers/Fields/EditorMedia/actions';
import Spiner from '../../../helpers/Spiner/Spiner';
import { changeQuestionSource, changeQuestionCategory } from '../../../../modules/questions';
import Modal from 'react-modal';
import {toastr} from 'react-redux-toastr'
import { showModal, QBM_CLEAR_STATISTIC_FORM } from '../../../../modules/modals';

const textValidate = addValidator({
  validator: function(options, value, allValues) {
    let tmp = value.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<br\/>/g, '').replace(/<br>/g, '').replace(/ /g, "")
    if(!tmp){
      return {
        id: "form.errors.question",
        defaultMessage: 'is required',
      }
    }
    return true
    
  }
})

class FormContentQuestion extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.deleteImages = [];
    this.state = {
      spinner: true,
      modal: false,
    }
    this.refAnswers = React.createRef();
    this.refQuestion = React.createRef();
  }
  
  
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        spinner: false
      })
    }, 400);

    setTimeout(() => {
      if(this.refQuestion.current && this.refQuestion.current.getRenderedComponent){
        const el = this.refQuestion.current.getRenderedComponent();
        if(el){
          el.focusEditor();
        }
      }
    }, 500)
  }
  

  componentWillUnmount(){
    if(this.deleteImages.length){
      deleteImgs(this.deleteImages)
    }
  }

  addedImage = (src) => {
    this.deleteImages.push(src);
  }

  save = async (data) => {
    const {formatMessage} = this.context;
    try {
      const {initialValues, changeQuestionSource, changeQuestionCategory, showModal} = this.props;

      this.setState({spinner: true});
      if(data.id){
        if(initialValues.category_id != data.category_id){
          changeQuestionCategory({questionId: data.id, category_id : 'cat_' + data.category_id, prev_category_id : 'cat_' + initialValues.category_id})
        }
        if(initialValues.subcategory_id != data.subcategory_id){
          changeQuestionCategory({questionId: data.id, category_id : 'subcat_' + data.subcategory_id, prev_category_id : 'subcat_' + initialValues.subcategory_id})
        }
        changeQuestionSource({questionId: data.id, source_id: data.source_id});

        showModal({
          modalType: QBM_CLEAR_STATISTIC_FORM,
          modalProps: {
            questionId: data.id
          }
        })
      }
      await this.props.saveQuestions(data);
      toastr.success(formatMessage('successMessageQuestionTitle'), formatMessage('successMessageQuestionMessage'))
      this.deleteImages = [];

      if(data.id){
        this.props.handleClose()
      } else{
        this.setState({spinner: false, modal: true});
        setTimeout(() => {
          if(window.goToLastPage){
            window.goToLastPage();
          }
        }, 400);
      }

    } catch (error) {
      this.setState({spinner: false})

      
    }
  }

  render() {
    const {handleSubmit, sources, subjects, categories, subcategories, initialValues, valuesForm, change} = this.props;
    const {spinner, modal} = this.state;
    const {formatMessage} = this.context
    const parent_categories = categories.filter(item => {
      return item.id.indexOf('subcat_') < 0 && item.subject_id == initialValues.subject_id ;
    });

    const children_categories = {};

    subcategories.forEach(item => {
      if(children_categories[item.parent_id.replace('cat_', '')]){
        children_categories[item.parent_id.replace('cat_', '')].push({
          title: item.name,
          value: item.id.replace('subcat_', '')
        })
      } else {
        children_categories[item.parent_id.replace('cat_', '')] = [{
          title: item.name,
          value: item.id.replace('subcat_', '')
        }]
      }
    });

    if(spinner){
      return <Spiner/>;
    }

    return (
      <form onSubmit={(e) => e.preventDefault()}>
        <Modal
          isOpen = {modal}
          style = {{
              overlay : {zIndex: 999999},
          }}
          onRequestClose={() => {}}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
        >
          <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseQuestionModalAndAdd')}</div>
          </div>
          <div className="create-dialog-modal-content__body">
            <div className="create-dialog-form form-quiz-create">
              <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextQuestionModalAdd')}</div>
              <div className="create-dialog-form__group flex">
                <button className="btn btn-primary" type="button" onClick={() => {
                  this.props.reset();
                  if(this.refAnswers.current){
                    this.refAnswers.current.resetAnswer();
                  }
                  this.setState({
                    modal: false
                  }, () => {
                    if(this.refQuestion.current && this.refQuestion.current.getRenderedComponent){
                      const el = this.refQuestion.current.getRenderedComponent();
                      if(el){
                        el.focusEditor();
                      }
                    }
                  });
                }}>{formatMessage('msgYesAdd')}</button>
                <button className="btn btn-warning" type="button" onClick={this.props.handleClose}>{formatMessage('No')}</button>
              </div>
            </div>
            
          </div>
        </Modal>
        <div className="row">
          <div className="col-md-12">
            <Field 
              name="subject_id" 
              label={formatMessage('Subject')} 
              component={SelectFieldAnt} 
              options={subjects.map(item => ({value: item.id, title: item.name}))}
              validate={[required()]}
              inputProps={{
                
                disabled: true
              }}
            />
            </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <Field 
              name="category_id" 
              label={formatMessage('Category')}
              component={SelectFieldAnt} 
              options={parent_categories.map(item => ({value: item.id.replace('cat_', ''), title: item.name}))}
              validate={[required()]}
              inputProps={{
              onChange: (value) => {
                change('category_id', value);
                change('subcategory_id', '');
              }
              }}
            />
          </div>
          <div className="col-md-6">
            <Field 
              name="subcategory_id" 
              label={formatMessage('Subcategory')}
              component={SelectFieldAnt} 
              options={valuesForm && valuesForm.category_id && children_categories[valuesForm.category_id] || []}
              inputProps={{
              
              }}
            />
          </div>
        </div>    

        <div className="row">
          <div className="col-md-6">
            <Field 
              name="source_id" 
              label={formatMessage('Sources')}
              component={SelectFieldAnt} 
              options={sources.map(item => ({value: item.id, title: item.name}))}
              inputProps={{
                
              }}
            />
          </div>
          <div className="col-md-6">
            <Field 
              name="difficulty" 
              label={formatMessage('Difficulty')}
              component={RateField} 
              inputProps={{
                count: 6
              }}
            />
          </div>
        </div>
        <Field name="question" label={formatMessage('Question')} ref={this.refQuestion} withRef addedImage={this.addedImage} validate={[textValidate()]} component={EditorMedia} />
        <Answers {...this.props} ref={this.refAnswers} />
        <Field name="description" label={formatMessage('Description')} addedImage={this.addedImage} component={EditorMedia} />
        <div className="action-save" style={{paddingBottom: 20}}>
          <button className="btn btn-primary" type="button" onClick={handleSubmit(this.save)}>{formatMessage('Save')}</button>
        </div>
      </form>
    );
  }
}

const FormContentData = reduxForm({
  form: 'form_qbm_question_and_answer',
  enableReinitialize: true,
})(FormContentQuestion);

const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_qbm_question_and_answer')(state),
  subjects : subjectsSelector(state) || {},
  sources : currentSubjectSourcesSelector(state) || {},
  categories : categoriesSelector(state) || {},
  subcategories : subcategoriesSelector(state) || {},
})

const mapDispatchToProps = {
  saveQuestions,
  changeQuestionSource,
  changeQuestionCategory,
  showModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContentData);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ModalFormQbm/components/FormContent.jsx